<script>
  /* global Global */
  import Dash from '../../symbols/Dash.svelte';
  import Common from '../../js/common.js';

  export let value;
  export let lang = undefined;

  const projectTitle = Global.project.title;
  const standings = Global.teams.standings;
</script>

<div class='standings'>
  <div class='standings-title'> {lang !== 'en' ? 'Předchozí umístění' : 'Previous standings'} </div>

  {#each standings as standing, idx}
    {#if value.standings[idx]}
      <a href={standing.link} class='standings-element' class:standings-element-no-hover={!standing.link}>
        <div class='standings-element-flag'>
          <img class='standings-element-flag-image' src='img/static/flag/{standing.flag}.svg' alt='{standing.flagAlt} flag'/>
        </div>

        <div class='standings-element-label'>
          <span class='standings-element-label-label'> {projectTitle[lang]} {standing.year} </span>

          <span class='standings-element-label-hyphen'> <Dash/> </span>

          <span class='standings-element-label-standing'>
            {#if lang !== 'en'}
              {value.standings[idx]}. místo
            {:else}
              {value.standings[idx]}{Common.getOrdinal(value.standings[idx])} place
            {/if}
          </span>
        </div>
      </a>
    {/if}
  {/each}
</div>

<style>
  .standings {
    display: flex;
    flex-direction: column;
    gap: 5px;
  }

  .standings-title {
    display: flex;
    align-items: center;

    height: 20px;

    margin-bottom: 25px;

    font-weight: bold;
  }

  .standings-element {
    display: flex;
    align-items: center;
    gap: 10px;

    height: 20px;

    text-decoration: none;

    color: inherit;
  }

  .standings-element-flag {
    display: flex;
    align-items: center;

    width: 24px;
  }

  .standings-element-flag-image {
    height: 16px;

    border-radius: 2px;

    box-shadow: 0px 0px 2px 0px var(--grey-4);
  }

  .standings-element-label {
    text-decoration: underline;
    text-decoration-thickness: 1.5px;
    text-decoration-color: transparent;

    transition: text-decoration-color 0.25s ease-in-out;
  }

  .standings-element:not(.standings-element-no-hover):hover .standings-element-label {
    text-decoration-color: var(--black);
  }

  .standings-element-label-standing {
    font-weight: bold;
  }

  :global(body.dark) .standings-element-flag-image {
    box-shadow: 0px 0px 2px 0px var(--black);

    filter: brightness(88%);
  }

  :global(body.dark) .standings-element:not(.standings-element-no-hover):hover .standings-element-label {
    text-decoration-color: var(--grey-3);
  }

  @media only screen and (max-width: 1250px) {
    .standings-title {
      margin-bottom: 0px;
    }
  }

  @media only screen and (max-width: 1050px) {
    .standings-title {
      margin-bottom: 25px;
    }
  }

  @media only screen and (max-width: 850px) {
    .standings-title {
      margin-bottom: 0px;
    }
  }

  @media only screen and (max-width: 450px) {
    .standings-element {
      height: 40px;
    }

    .standings-element-label {
      display: flex;
      flex-direction: column;
    }

    .standings-element-label-label {
      display: flex;
      align-items: center;
      height: 20px;
    }

    .standings-element-label-hyphen {
      display: none;
    }

    .standings-element-label-standing {
      display: flex;
      align-items: center;
      height: 20px;
    }
  }
</style>
